












































































































































































import car from '@/modules/carRegister/Car.vue'
import { Vue, Component } from 'vue-property-decorator'
import { Group, Cell, Confirm, XTextarea } from '@lx-frontend/cvux'
// @ts-ignore
import ImagesPreviewer from '@lx-frontend/images-previewer'
import { isTrueNumber, numberDiv100Fixed2 } from '@/common/number'

@Component({
  components: {
    Group,
    Cell,
    Confirm,
    XTextarea,
    ImagesPreviewer
  },
  filters: {
    isCustomer({ name, phone }: {name: string, phone: string}) {
      if (!name && !phone) return '--'
      return `${name || '--'} ${phone || '--'}`
    },
    workflowActionState(status: number) {
      const state: { [key: number]: string } = {
        0: '未知',
        1: '已创建',
        2: '审核中',
        3: '已通过',
        4: '已驳回',
        5: '已关闭'
      }
      return state[status] || '--'
    },
    // 卡券发放交易类型
    couponsSendRequestTransactionType(status: number) {
      const state: { [key: number]: string } = {
        1: '赠送',
        2: '购买'
      }
      return state[status] || '--'
    },
    formatePrice(price: number) {
      return isTrueNumber(price) ? `${numberDiv100Fixed2(price)}元` : '--'
    }
  }
})
export default class CardCheckDetail extends Vue {
  hasAuthOuponsReview = false // 审核权限

  cardDetail = {
    car_model_id: 0,
    pdf_json: '',
    cost_department: '',
    coupon_packages: [{
      coupon_count: 2,
      coupons: [{
        num: 10,
        title: ''
      }],
      num: 1,
      title: '',
      total_coupon_count: 2
    }],
    coupons: [
      {
        cost_price: 0,
        effect_time: '',
        expire_time: '',
        expires: '',
        num: 0,
        title: ''
      }
    ],
    customer: {
      display_name: '',
      mobile_number: ''
    },
    gift_cards: [{
      expires: 0,
      face_value: 0,
      num: 0,
      quota: 0,
      title: '',
      effect_time: '',
      expire_time: ''
    }],
    images: [],
    plate_number: '',
    reason: '',
    review_flow: null as null | {
      can_review: boolean
      status: number
      step_count: number
      step_no: number
      steps: {
        optional_reviewers: string[]
        reviewer: string
        review_time: string
        reviewer_id: number
        reason: string
        status: number
      }[]
    },
    status: 0,
    submit_time: '',
    submitter: '',
    transaction_amount: 0,
    transaction_type: 0,
    vin: ''
  }
  auditForm = {
    id: 0,
    showRejectConfirm: false,
    rejectText: ''
  }
  imageList = []
  options = {
    getThumbBoundsFn (index: number) {
      let isServer = typeof window === 'undefined'
      if (isServer) return
      let thumbnail = document.querySelectorAll('.previewer-img')[index]
      let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
      let rect = thumbnail.getBoundingClientRect()
      return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
    }
  }

  getWorkflowActionStateIcon () {
    if (!this.cardDetail.review_flow) return ''
    const status = this.cardDetail.review_flow.status
    const state: { [key: number]: string } = {
      2: 'underway',
      3: 'pass',
      4: 'reject',
      5: 'closed'
    }
    return state[status]
  }
  async getReviewDetail() {
    const id = +this.$route.query.id
    const { code, data, message } = await this.$rest.cardCheck.getReviewDetail(id)({ time: new Date().getTime() })
    if (code !== 0) {
      this.showToast(message)
      return
    }
    this.cardDetail = {
      ...this.cardDetail,
      ...data,
      review_flow: data.review_flow || null
    }
  }

  created () {
    this.$store.state.promiseAuth.then((auth: { authList: string }) => {
      const { authList } = auth
      this.hasAuthOuponsReview = authList.includes('coupons.issue_workflow.review')
      if (authList.includes('coupons.issue_workflow.view')) {
        this.getReviewDetail() // 获取审批单详情
      } else {
        this.showToast('暂无查看权限')
      }
    })
  }

  get pdfJson() {
    if (!this.cardDetail.pdf_json) {
      return []
    }

    const pdfList = JSON.parse(this.cardDetail.pdf_json)

    return Object.keys(pdfList).map(
      (key) => ({
        key,
        pdf_name: pdfList[key].pdf_name.split('.')[0],
        pdf_url: pdfList[key].pdf_url
      })
    )
  }

  async handleConfirm () {
    if (!this.auditForm.rejectText) {
      this.showToast('请填写驳回原因')
      return
    }
    const id = +this.$route.query.id
    const { code, message } = await this.$rest.cardCheck.updateReviewReject(id)({
      reason: this.auditForm.rejectText
    })
    if (code !== 0) {
      this.showToast(message)
      return
    }
    this.showToast('驳回成功')
    this.auditForm.showRejectConfirm = false
    this.getReviewDetail()
  }

  handleReject () {
    this.auditForm.rejectText = ''
    this.auditForm.showRejectConfirm = true
  }

  async handleSubmit () {
    const id = +this.$route.query.id
    const { code, message } = await this.$rest.cardCheck.updateReviewApprove(id)()
    if (code !== 0) {
      this.showToast(message)
      return
    }
    this.showToast('审核通过')
    this.getReviewDetail()
  }

  goPic(current: string, urls: string[]) { // 查看图片
    this.$wechat.wx.previewImage({
      current,
      urls
    })
  }
}
